/**
 * Centralized constants for wheel animation timing and configuration
 * Ensures synchronization between the wheel component CSS and hook logic
 */

// Animation durations (in milliseconds)
export const WHEEL_ANIMATION = {
  /** Main spin animation duration - must match CSS transition duration */
  SPIN_DURATION_MS: 6000,

  /** CSS timing function for the spin animation */
  TIMING_FUNCTION: "cubic-bezier(0.23, 1, 0.32, 1)",
} as const;

// Derived values for easier usage
export const WHEEL_ANIMATION_DERIVED = {
  /** Spin duration in seconds for CSS */
  SPIN_DURATION_S: WHEEL_ANIMATION.SPIN_DURATION_MS / 1000,

  /** Complete CSS transition string for spinning state */
  SPIN_TRANSITION: `transform ${WHEEL_ANIMATION.SPIN_DURATION_MS / 1000}s ${WHEEL_ANIMATION.TIMING_FUNCTION}`,
} as const;

// Wheel mechanics constants
export const WHEEL_MECHANICS = {
  /** Number of full rotations for dramatic effect */
  FULL_ROTATIONS: 7,

  /** Random offset percentage within segment (0-1) */
  SEGMENT_RANDOM_OFFSET: 0.8,

  /** Degrees adjustment for top arrow position */
  TOP_ARROW_ADJUSTMENT: -90,
} as const;
